import React, {Component} from 'react';

class LoadingOverlayComponent extends Component {
	render() {
		return <>Loading</>;
	}
}

export default LoadingOverlayComponent;
